import { fade, makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  root: {
    "& .k-grid": {
      height: "70vh",
    },
  },
  tabs: {
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("xs")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
    [theme.breakpoints.down("xs")]: {
      position: "fixed",
      top: 10,
      right: 45,
      background: "#fff",

      "&:hover": {
        background: "#fff",
      },
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: () => {
    const iconColor = "#a5a5a5";
    return {
      color: "inherit",
      [theme.breakpoints.down("xs")]: {
        position: "fixed",
        right: 42,
        background: "#fff",
      },
      "& svg": {
        position: "absolute",
        right: 12,
        fontSize: 25,
        color: iconColor,
        cursor: "pointer",
      },
      "& input": {
        cursor: "pointer",
      },
      "&.Mui-focused": {
        "& input": {
          cursor: "inherit",
        },
      },
    };
  },
  inputInput: {
    fontSize: 14,
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("xs")]: {
      width: "0",
      padding: "6px 32px 6px 6px",
      zIndex: "1",
      "&:focus": {
        width: "18ch",
        borderBottom: "solid 1px #D5DAEC",
        [theme.breakpoints.down("xs")]: {
          width: "62vw",
        },
      },
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
    "&.expandInput": {
      width: "18ch",
      transition: theme.transitions.create("width"),
      borderBottom: "solid 1px #D5DAEC",
    },
  },
  searchbarLoader: {
    position: "absolute",
    right: 3,
    "& .MuiCircularProgress-root": {
      height: "30px !important",
      width: "30px !important",
      animation: "none",
      marginTop: 12,
    },
  },
  closeBtn: {
    marginTop: "-12px",
    zIndex: "2",
    cursor: "pointer",
  },
  coverImg: {
    width: 50,
    height: 31,
    objectFit: "cover",
    borderRadius: 4,
  },
  popover: {
    cursor: "pointer",
  },
  /* Vertical Stepper Start*/
  scrollContent: {
    width: "100%",
    height: "100%",
    "& .track-vertical": {
      right: 0,
      height: "100%",
      background: "#cac9c9",
      borderRadius: 3,
    },
    "& .thumb-vertical": {
      background: "#8a8a8a",
      borderRadius: 3,
    },
  },
  verticalStepper: {
    "& .MuiAvatar-root": {
      width: "54px",
      height: "54px",
      marginBottom: "5px",
    },

    "& .MuiStepLabel-root.MuiStepLabel-vertical": {
      position: "relative",
      width: "80px",
      overflow: "hidden",
      right: "0",
      top: "0",
      float: "right",
      "& .MuiSvgIcon-root.Mui-completed": {
        display: "block",
        color: "#1EC277",
      },
    },
    "& .MuiStepConnector-root, & .MuiStepIcon-root, & .MuiStepConnector-line, &.MuiCollapse-vertical.MuiStepContent-transition":
      {
        display: "none",
        border: "0 none",
      },
    "& .MuiStepLabel-label": {
      display: "block",
      fontWeight: "600 !important",
      width: "100%",
      textOverflow: "ellipsis",
      letterSpacing: "0",
      overflow: "hidden",
      textAlign: "center",
      fontSize: "14px",
      lineHeight: "15px",
      color: "#000!important",
      whiteSpace: "nowrap",
    },
    "& .MuiStepLabel-label.Mui-disabled": {
      opacity: "0.2",
    },
    "& .MuiStepConnector-line": {
      display: "none",
      border: "0 none",
    },
    "& .MuiStepContent-root": {
      marginLeft: "0",
      paddingLeft: "0",
      paddingRight: "8px",
      borderLeft: "0 none",
    },
  },
  verticalToggle: {
    "& .MuiToggleButtonGroup-grouped": {
      fontFamily: `'Poppins', sans-serif`,
      width: "400px",
      height: "40px",
      textAlign: "center",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "15px",
      color: "#283941",
      marginBottom: "10px",
      border: "1px solid #DCE1E4 !important",
      borderRadius: "6px !important",
      textTransform: "none",
      "&:hover, &.MuiToggleButton-root.Mui-selected, &.MuiToggleButton-root.Mui-selected:hover":
        {
          background: "#FFEFE2",
          borderColor: "#F9A36C!important",
        },
      "@media(max-width: 599.95px)": {
        width: "96%",
      },
    },
  },
  /* Horizontal Stepper Start*/
  horizontalStepper: {
    fontFamily: `'Poppins', sans-serif`,
    padding: "10px 40px",
    position: "relative",
    overflow: "hidden",
    width: "85%",
    margin: "0 auto",
    display: "block",
    "& .MuiStep-horizontal": {
      boxShadow: "0 3px 6px #00000029",
      borderRadius: "8px",
      padding: "10px",
      minWidth: "169px",
      display: "block",
      float: "left",
      textAlign: "left",
      height: "52px",
      position: "relative",
      marginRight: "12px",
      "& .MuiStepIcon-root": {
        color: "#1EC277",
        position: "absolute",
        zIndex: "1",
        top: "26px",
        left: "36px",
        width: "16px",
        height: "16px",
      },
    },
    "& .MuiAvatar-root": {
      width: "32px",
      height: "32px",
      marginRight: "14px",
      fontSize: "15px",
    },
    "& .MuiStepLabel-horizontal": {
      display: "block",
    },
    "& .MuiStepConnector-root, & .MuiStepIcon-root": {
      display: "none",
    },
    "& .MuiSvgIcon-root.Mui-completed": {
      display: "block !important",
    },
    "& .MuiStepConnector-root.Mui-active + .MuiStep-root": {
      borderBottom: "3px solid #F3994E",
      background: "#F7F7F8",
    },
    "& .MuiStepLabel-label": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "100%",
    },
    "& .MuiStepLabel-label.Mui-active, & .MuiStepLabel-label.Mui-completed, & .MuiStepLabel-label":
      {
        display: "inline-flex",
      },
    "& .MuiStepLabel-label.Mui-active, & .MuiStepLabel-label.Mui-completed": {
      color: "#283941",
      fontSize: "14px",
      lineHeight: "32px",

      "&.Mui-disabled": {
        color: "#5C5C5C",
      },
      "& .MuiBox-root": {
        top: "0",
        left: "0",
        width: "46px",
        position: "relative",
      },
      "& .MuiTypography-root": {
        marginTop: "5px",
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "12px",
      },
    },
    "& .MuiStepLabel-root.MuiStepLabel-horizontal": {
      "& .MuiStepLabel-labelContainer": {
        "& .MuiTypography-root.MuiTypography-body2": {
          color: "#2E2E2E",
          letterSpacing: "0",
          fontSize: "14px",
          marginTop: "7px",
          fontWeight: "500",
          lineHeight: "12px",
        },
      },
    },
    "& .MuiButton-root": {
      background: "#FFFFFF",
      boxShadow: "0 3px 6px #00000029",
      minWidth: "31px",
      width: "31px",
      height: "31px",
      borderRadius: "70%",
      padding: "10px",
      "& .MuiSvgIcon-root": {
        color: "#707070",
      },
      "&.leftArrow": {
        float: "left",
        left: "0",
      },
      "&.rightArrow": {
        float: "right",
        right: "0",
      },
    },
    "& .MuiBox-root": {
      position: "absolute",
      top: "20px",
      width: "100%",
      left: "0",
    },
    "& .alice-carousel": {
      zIndex: "1",
      width: "100%",
      "& .alice-carousel__wrapper": {
        height: "60px",
        textAlign: "left",
        padding: "0 4px !important",
        "& .alice-carousel__stage": {
          textAlign: "center",
        },
        "& .alice-carousel__stage-item.__active.__target, & .alice-carousel__stage-item.__active, & .alice-carousel__stage-item":
          {
            "& .MuiStepLabel-labelContainer": {
              display: "block",
              "& .MuiStepLabel-label": {
                "& .MuiBox-root": {
                  top: "0",
                  width: "46px",
                  left: "0",
                  position: "relative",
                },
              },
            },
          },
        "& .alice-carousel__stage-item.__active.__target": {
          "& .MuiStep-root.MuiStep-horizontal": {
            "& .MuiStepLabel-label": {
              "& .MuiBox-root": {
                top: "0",
                width: "46px",
                left: "0",
                position: "relative",
              },
            },
          },
          "& .MuiStep-root.MuiStep-horizontal": {
            borderBottom: "3px solid #F3994E",
            background: "#F7F7F8",
            width: "100%",
          },
        },
        "& .alice-carousel__stage-item.__active": {
          "& .Mui-completed": {
            "& .MuiStepLabel-iconContainer": {
              display: "block",
            },
          },
        },
        "& .alice-carousel__stage-item": {
          width: "169px !important",
          marginRight: "15px",
          cursor: "pointer",
          "&:lastChild": {
            marginRight: "0",
          },
          "& .MuiStepLabel-iconContainer": {
            display: "block",
          },
        },
      },
    },
  },
  targetReviewModal: {
    "& Scrollbars": { background: "#fff" },
    "& .Orangetext": {
      color: "#EF7713",
    },
    "& .MuiCard-root": {
      width: "90%",
      margin: "0 auto",
      boxShadow: "0 3px 6px #00000029",
    },
    "& .MuiDialog-paper": {
      width: 1000,
      maxWidth: "none",
      overflow: "unset",
      height: 700,
    },
    "& .MuiDialogTitle-root": {
      boxShadow: "0px 1px 3px #00000029",
      zIndex: "1",
      "& h2": {
        fontSize: 18,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      },
    },

    "& .target-name": {
      padding: "20px",
      position: "sticky",
      width: "100%",
      top: "0",
      zIndex: "4",
      "& .target-Img": {
        width: "175px",
        height: "75px",
        borderRadius: "10px",
      },
      "& h6": {
        fontSize: "17px",
        lineHeight: "18px",
        fontWeight: "600",
        letterSpacing: "0",
        color: "#283941",
      },
      "& .target-Type": {
        display: "none",
      },
      "& .width76": {
        width: "76%",
      },
      "& .target-Info": {
        alignItems: "flex-start",
        flexDirection: "unset",
        justifyContent: "flex-start",
        position: "relative",
        width: "100%",
        "& .date": {
          width: "100%",
          lineHeight: "15px",
          fontSize: "14px",
          color: "#283941",
          display: "block",
          margin: "5px 0",
        },
        "& .desc": {
          width: "100%",
          lineHeight: "14px",
          fontSize: "12px",
          color: "#283941",
          "& p": { margin: "5px 0 0 0" },
        },
        "& .lblChip": {
          top: "-20px",
          color: "#fff",
          right: "-20px",
          border: "0 none",
          padding: "5px 12px",
          position: "absolute",
          fontSize: "12px",
          background: "#596581",
          lineHeight: "15px",
          borderRadius: "0",
          borderBottomLeftRadius: "15px",
          "& .MuiChip-label": {
            padding: "0",
          },
        },
      },
    },
    "& .MuiCardActions-root": {
      "& .MuiButton-root": {
        marginRight: "15px",
      },
    },
  },

  /* Horizontal Stepper End*/
  coachRate: {
    fontFamily: `'Poppins', sans-serif`,
    "& .MuiButton-root.mr-2": {
      marginRight: "15px",
    },
    "& .MuiCard-root": {
      width: "84%",
      margin: "0 auto 20px auto",
      boxShadow: "0 3px 6px #00000029",
      borderRadius: "10px",
      "& .MuiTypography-root": {
        fontSize: "17px",
        lineHeight: "14px",
        letterSpacing: "0",
        color: "#2E2E2E",
        marginTop: "20px",
        "& h6.MuiTypography-root": {
          marginBottom: "30px",
          color: "#5C5C5C",
        },
      },
      "& .MuiFormControlLabel-root .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1":
        {
          color: "#2E2E2E !important",
          lineHeight: "20px",
          textAlign: "left",
          margin: 0,
        },
    },
  },
  leadReviewerRate: {
    "& .rateuser": {
      "& h6.MuiTypography-root": {
        fontSize: "14px",
        lineHeight: "2px",
        fontWeight: "500",
        color: "#5C5C5C",
      },
    },
    fontFamily: `'Poppins', sans-serif`,
    "& .complete": {
      position: "relative",
      "& button": {
        position: "absolute",
        right: "0",
        bottom: "30px",
      },
    },
    "& .gridWarp": {
      padding: "0",
      "& .MuiBox-root.text-center": {
        padding: "20px 0",
      },
      "& .k-pager-wrap.k-pager": {
        padding: "20px",
        "& .k-pager-info.k-label": {
          justifyContent: "flex-start",
          fontSize: "12px",
          letterSpacing: "0",
          color: "#8C8C8C",
        },
      },
    },
    "& .MuiButton-root.mr-2": {
      marginRight: "15px",
    },
    "& .btnwrap": {
      width: "92%",
      display: "block",
      float: "left",
      position: "relative",
      "& .savesub": {
        margin: "15px 0",
        position: "relative",
        bottom: "10px",
        right: "0",
        float: "right",
        background: "#FCFDFF",
        boxShadow: "0 1px 2px #B9BCC05E",
        border: "1px solid #DDEEFF",
        borderRadius: "8px",
        padding: "12px 24px",

        "& .MuiButton-label": { fontSize: "14px", color: "#07519C" },
      },
    },

    "& .MuiCard-root": {
      width: "84%",
      margin: "0 auto 20px auto",
      boxShadow: "0 3px 6px #00000029",
      borderRadius: "10px",

      "& .MuiTypography-root": {
        fontSize: "17px",
        lineHeight: "14px",
        letterSpacing: "0",
        color: "#2E2E2E",
        marginTop: "20px",
        "& h6.MuiTypography-root": {
          marginBottom: "30px",
          color: "#5C5C5C",
        },
      },
      "& .MuiFormControlLabel-root .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1":
        {
          color: "#2E2E2E !important",
          lineHeight: "20px",
          textAlign: "left",
          margin: 0,
        },
    },
    "& .k-grid-header": {
      background: "#EDEEEF",
      "& .k-grid-header-wrap": {
        border: "0 none",
        "& .checkbox-icon": {
          width: "22px",
          height: "22px",
        },
      },
      "& .k-icon": {
        marginTop: "-12px",
        verticalAlign: "middle !important",
      },
      "& .k-i-sort-asc-sm": {
        marginTop: "0",
      },
      "& .k-i-sort-desc-sm": {
        marginTop: "-0",
      },
      "& .k-link:hover::after": {
        top: "15px",
      },

      "& .k-header:first-child": {
        padding: 14,
        "& .k-icon": {
          display: "none",
        },
      },
    },
    "& .k-link.k-state-selected": {
      background: "#EEEEEE",
      border: "0 none",
      padding: "2px 10px",
      fontSize: "12px",
      fontWeight: "14px",
      color: "#2E1F1E",
    },
    "& .k-link.k-pager-nav": {
      background: "transparent",
    },
    "& .k-pager-numbers .k-link:hover, & .k-pager-numbers .k-link.k-state-hover":
      {
        background: "none",
        color: "#000",
      },
    "& .k-grid-table": {
      fontFamily: `'Poppins', sans-serif`,
      "& .k-header": {
        "& .k-link": {
          fontSize: "12px",
          fontWeight: "600",
          color: "#000",
        },
      },
    },
  },
  coacheeRate: {
    fontFamily: `'Poppins', sans-serif`,
    "& .MuiCard-root": {
      width: "84%",
      margin: "0 auto 20px auto",
      boxShadow: "0 3px 6px #00000029",
      borderRadius: "10px",
      "& .MuiCardContent-root": {
        padding: "30px",
        "& .MuiTypography-root": {
          fontSize: "17px",
          lineHeight: "14px",
          letterSpacing: "0",
          color: "#2E2E2E",
          marginTop: "20px",
        },
        "& h6.MuiTypography-root": {
          marginBottom: "30px",
          color: "#5C5C5C",
        },
      },
    },
    "& .commentA, & .MuiDialogActions-root": {
      width: "500px",
      margin: "0 auto",
      display: "block",
      "& .MuiTypography-root": {
        color: "#5C5C5C !important",
        marginBottom: "5px",
        textAlign: "left !important",
        fontSize: "14px !important",
      },
      "&. MuiOutlinedInput-input": {
        fontSize: "12px",
      },
      " & .MuiFormLabel-root.MuiInputLabel-root": {
        textAlign: "left",
      },
      "&.MuiDialogActions-root": {
        textAlign: "right",
        padding: "0",
        marginTop: "25px",
      },
    },
  },
  carouselWrap: {
    "& .alice-carousel": {
      "& .alice-carousel__dots": {
        marginTop: 10,
        position: "absolute",
        bottom: -26,
        left: "38%",
      },
      "& .alice-carousel__dots-item:not(.__custom)": {
        width: 6,
        height: 6,
        marginRight: 10,
      },
    },
    "& .slider-count": {
      color: "#99A1A5",
      position: "absolute",
      bottom: -24,
      right: "30%",
    },
    "& .question": {
      fontSize: 24,
      lineHeight: 32,
      marginTop: 74,
    },
    "& .btnHint": {
      fontSize: 12,
      marginTop: 59,
    },
    "& button.MuiButton-text": {
      background: "#FAFAFA",
      borderRadius: "14px !important",
      fontSize: 13,
      color: "#707E8C",
      border: "1px solid #FAFAFA !important",
      lineHeight: 21,
      fontWeight: 500,
      marginRight: 20,
      "&:hover": {
        color: "#B45F18",
        background: "#F4E6D9",
        borderColor: "#F9A36C!important",
      },
    },
    "& .item .MuiBox-root p.MuiTypography-root": {
      fontSize: 12,
      color: "#FFFFFFE0",
    },
  },
  carouselWidth: {
    "& .horizontal-tab": {
      "& header.MuiPaper-root": {
        "& button.MuiButtonBase-root": {
          padding: "7px 15px",
          width: "auto",
        },
      },
    },
  },

  verticalStepper: {
    height: 340,
    width: 100,
    marginTop: 72,
    marginLeft: 20,
    "& .MuiStepper-root": {
      padding: "0 10px 0 0",
    },
    "& .MuiStepConnector-line": {
      border: "0 none",
    },
    "& .MuiStep-root.MuiStep-vertical": {
      position: "relative",
      marginBottom: 50,
      "& .MuiStepLabel-vertical": {
        position: "absolute",
        right: 10,
        top: 0,
        width: 60,
        "& .avatar-img": {
          width: 50,
          height: 50,
        },
        "& .MuiStepIcon-root.MuiStepIcon-completed": {
          color: "#1EC277",
          width: 16,
          height: 16,
          top: 38,
          position: "absolute",
          zIndex: 1,
          left: 50,
        },
        "& .MuiStepLabel-label.MuiStepLabel-completed, & .MuiStepLabel-label.MuiStepLabel-active":
          {
            fontWeight: 600,
          },
        "& .MuiStepIcon-root": {
          display: "none",
        },
        "& .MuiTypography-root.font-13": {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
        },
      },
      "& .MuiStepContent-root": {
        border: "none",
        margin: 0,
        padding: 0,
        width: "calc(100% - 100px)",
      },
      "& .btnWrap": {
        position: "absolute",
        right: 180,
        top: 0,
        zIndex: 10,
        "& .MuiButton-root": {
          position: "absolute",
          left: 10,
          top: 0,
          "&.MuiButton-text": {
            left: 120,
          },
        },
      },
    },
  },
  sksCheckin: {
    padding: "16px 24px 0",
    width: "100%",
  },
  sksAnimation: {
    width: "100%",
    position: "absolute",
  },
  sksCarousel: {
    position: "relative",
    "& .alice-carousel__dots": {
      marginTop: 75,
    },
    "& .arrow-buttons": {
      top: "36%",
      position: "absolute",
      left: 0,
      padding: "0 20px",
      width: "100%",
      "& .prev-btn": {
        float: "left",
      },
      "& .next-btn": {
        float: "right",
      },
      "& .MuiIconButton-label": {
        background: "#FFFFFF",
        border: "2px solid #F0F0F0",
        borderRadius: 50,
        "& .MuiSvgIcon-root": {
          color: "#07519C",
        },
      },
      "& .Mui-disabled": {
        opacity: 0.3,
      },
    },
  },
  previewIndicator: {
    position: "fixed",
    left: 0,
    bottom: 0,
    color: "#fff",
    "& svg": {
      width: 50,
      height: 28,
    },
  },
  removePaddingRight: {
    "& .k-grid .k-grid-header": {
      paddingRight: "unset",
    },
  },
  inputRoot: () => {
    const iconColor = "#a5a5a5";
    return {
      color: "inherit",
      [theme.breakpoints.down("xs")]: {
        position: "fixed",
        right: 42,
        background: "#fff",
      },
      "& svg": {
        position: "absolute",
        right: 12,
        fontSize: 25,
        color: iconColor,
        cursor: "pointer",
      },
      "& input": {
        cursor: "pointer",
        fontWeight: 400,
      },
      "&.Mui-focused": {
        "& input": {
          cursor: "inherit",
          borderBottom: "#E9954C solid 1px",
        },
      },
    };
  },
  filterPopper: {
    background: "#fff",
    width: "100%",
    border: "solid 1px #CCCCCC",
    borderRadius: 8,
    marginTop: 5,
    boxShadow: "0px 1px 12px #00000029",
  },
  searchDropdown: {
    width: 270,
  },
  inputInput1: {
    fontSize: 14,
    fontWeight: 600,
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    // paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    // width: "100%",
    transition: theme.transitions.create("width"),
    width: "100%",
    borderBottom: "solid 1px #D5DAEC",
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  closeBtn: {
    marginTop: "-12px",
    zIndex: "2",
    cursor: "pointer",
  },
  filterBtn: {
    width: 40,
    height: 40,
    borderRadius: 8,
    border: "solid 2px #F0F0F0",
    minWidth: "auto",
  },
}));
